import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useUpdateOrdemServico() {
  return useMutation(URL.ORDEM_SERVICO.OBTER, async (body: any) => {
    const response = await http.put(URL.ORDEM_SERVICO.TALHOES, body);
    return response;
  });
}

export default useUpdateOrdemServico;
